import { render, staticRenderFns } from "./SevenPcb.vue?vue&type=template&id=72d6c2e2&scoped=true&lang=html&"
import script from "./SevenPcb.vue?vue&type=script&lang=js&"
export * from "./SevenPcb.vue?vue&type=script&lang=js&"
import style0 from "./SevenPcb.vue?vue&type=style&index=0&id=72d6c2e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d6c2e2",
  null
  
)

export default component.exports